import * as React from "react";
import {Component} from "react";
import Table from "../../components/Table";
import {__, getLocalized, getURLParam, mapStateToProps, setTableParams} from "../../core/utils";
import {createSuperadminSidebar} from "../../redux/actions/general/sidebar";
import {listActiveModules} from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import {setPlusActions} from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import {hideAlertbox, showAlertbox} from "../../redux/actions/general/alertbox";
import {setNotification} from "../../redux/actions/general/notification";
import {
	deleteFunctionalSpaces,
	listFunctionalSpaces,
	readFunctionalSpace
} from "../../redux/actions/table/superadmin/functional_spaces";
import FunctionalSpacesFlyout from "../../flyouts/superadmin/functional_spaces/FunctionalSpacesFlyout";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_functional_spaces"],
	application_language_id: state.auth.language_id,
}))
class FunctionalSpaces extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_functional_space && setPlusActions([{
			title: "Add functional space",
			onClick: () => setTableParams('superadmin_functional_spaces', {
				add_functional_space_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readFunctionalSpace(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => getLocalized(name, application_language_id)
			},
		];

		const singleActions = (functional_space_id) => {
			return [
				<Tooltip text="Delete selected functional space" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected functional space?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteFunctionalSpaces([functional_space_id]).then(() => {
												hideAlertbox();

												setNotification("The selected functional space has been deleted.");
												listFunctionalSpaces();

												setTableParams('superadmin_functional_spaces', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (functional_spaces_ids) => [
			<Tooltip text="Delete selected functional spaces" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these functional spaces?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteFunctionalSpaces(functional_spaces_ids).then(() => {
											hideAlertbox();

											setNotification("The selected functional spaces have been deleted.");
											listFunctionalSpaces();

											setTableParams('superadmin_functional_spaces', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<FunctionalSpacesFlyout
				data={this.state.preview}
				readAction={functional_space_id => {
					return new Promise(resolve => {
						readFunctionalSpace(getURLParam('id') || functional_space_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listFunctionalSpaces}
				name="superadmin_functional_spaces"
				groupActions={superadmin.delete_functional_space && groupActions}
				singleActions={superadmin.delete_functional_space && singleActions}
				title={__("modules.submodules.title.functional-spaces")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default FunctionalSpaces;
